import { EncryptionService } from '../../_services/encryption.service';
import { CsvdownloadService } from '../../_services/csvdownload.service';
import { CountExpirate } from '../../_models/count-expirate.model';
import { ClaimOperationCPService } from '../../_services/claim-operation-cp.service';
import { ClaimOperationCP } from '../../_models/claim-operation-cp.model';
import { Component, Input, OnInit } from '@angular/core';
import { CountStates } from 'src/app/_models/count-states.model';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { StateMasterService } from 'src/app/_services/state-master.service';
import { DatePipe } from '@angular/common';
import { StorageService } from 'src/app/_services/storage.service';
import { Routes } from 'src/app/_config/routes.config';
import { Formats } from 'src/app/_config/formats';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DisputeReasons } from 'src/app/_services/dispute-reasons.service';
import { SubReasonsDTO } from 'src/app/_models/ReasonsDTO.model';
import { firstValueFrom } from 'rxjs';
import { PagedResponseDTO } from '../../_models/claim-operation-PagedResponseDTO.model copy';
import { ColumnItem } from 'src/app/_models/column-item.model';
import { Observable } from 'rxjs';
import { ViewChild, ElementRef } from '@angular/core';

declare var bootstrap: any;
@Component({
  selector: 'DCO-disputes',
  templateUrl: './disputes.component.html',
  standalone: false,
})
export class DisputesComponent extends BaseComponent implements OnInit {


  
  dateformat = Formats.date;
  currentFormats: any;
  currentLanguage: string;
  disputeReasons: SubReasonsDTO[];
  reasons: string[] = [];
  subReasonsParameters: any = {
    Operations: '0',
    Offset: 0,
    CountLimit: 0,
  };

  page: number = 1;
  loadCompleted: boolean = false;

  //Encriptación
  code: string;
  codemassive: string;
  routeMassive: string;

  //Tab pendientes
  tabName: string = '';
  showBtnPendings: boolean = false;

  //Tab gestionadas
  lstStatesMasters: CountStates[] = [];
  statesIds: any[] = [];

  //Tab total
  total: number;

  //Tab vencen hoy
  dateNow = new Date();
  today: string;
  nextWeek: string = this.datePipe.transform(
    this.AddDays(this.dateNow, +7),
    'yyyy-MM-dd',
  );

  //Conteo para tabs proximas vencimiento/vencen hoy
  countClaimsOperations: CountExpirate= new CountExpirate();;

  //Top 5
  TopFive: boolean = false;

  //Estados disputas
  claimOperationStates: CountStates[]=[];

  //Informacion masiva
  counter: number = 0;
  massiveInfoButton: boolean = false;
  claimOperationIDs: string = '';
  claimIDs: string = '';

  //Boton editar y visualizar
  showBtnEdit: boolean = true;
  showBtnVisualize: boolean = false;

  // Checkboxes
  selectedIndices: number[] = [];
  isAllSelected: boolean = false;

  //Modal Quitar despues de eliminar enabling????
  display = 'none';
  enable = false;

  //boolean para mostrar la columna fecha de venimiento
  dueDate: boolean = true;

  state: string | null = null;

  //
  //SearchHelper
  claimOperations: ClaimOperationCP[] = [];
  claimOperationsSubReasonDYF: ClaimOperationCP[] = [];
  claimOperationsRequestDTO: PagedResponseDTO<ClaimOperationCP>;
  claimID: string = '';
  operatorClaimID = '';
  commerceName: string = '';
  operatorCommercename = '';
  disputesDNI: string = '';
  operatorDisputesDNI = '';
  commerceNumber: string = '';
  operatorCommercenumber = '';
  subreasonName: string = '';
  operatorSubreasonname = '';
  businessActivity: string = '';
  operatorBusinessactivity = '';
  operationDate: string = '';
  operationDateEnd: string = '';
  operatorOperationdate = '';
  operationDateday: string = '';
  operationDatemonth: string = '';
  operationDateyear: string = '';
  operatorArn: string = '';
  arn: string = '';
  nombreComercio: string = '';
  operatorNombrecomercio = '';
  amount: string = '';
  amountEnd: string = '';
  operatorAmount = '';
  cardType: string = '';
  operatorCardType = '';
  bin: string = '';
  operatorBin = '';
  lastChangeDate: string = '';
  lastChangeDateEnd: string = '';
  operatorLastChangeDate = '';
  operationLastChangeDateday: string = '';
  operationLastChangeDatemonth: string = '';
  operationLastChangeDateyear: string = '';
  topCount: number = 0;
  searchvariables = [];
  operatorSearchvariables = [
    this.operatorClaimID || '',
    this.operatorArn || '',
    this.operatorCommercenumber || '',
    this.operatorSubreasonname || '',
    this.operatorBusinessactivity || '',
    this.operatorOperationdate || '',
    this.operatorNombrecomercio || '',
    this.operatorCardType || '',
    this.operatorBin || '',
    this.operatorLastChangeDate || '',
    this.operatorAmount || '',
  ];
  paramsearchvariables: string;
  tagsearchvariables: string[] = [
    'claimoperationID',
    'Arn',
    'CommerceNumber',
    'SubReason_Name',
    'BusinessActivity',
    //`CONVERT(varchar, CL.DOC, 120)`,
    'Claims_DisputeStartDate',
    'Contacts_CommerceName',
    'Operation_PaymentScheme',
    'OperationsCard',
    //`CONVERT(varchar, HS.LastUpdate, 120)`,
    'HistoricStates_EntryDate',
    'Amount'
  ];
  typesearchvariables: string[] = [
    'int',
    'varchar',
    'varchar',
    'varchar',
    'int',
    //`CONVERT(varchar, CL.DOC, 120)`,
    'date',
    'varchar',
    'int',
    'varchar',
    //`CONVERT(varchar, HS.LastUpdate, 120)`,
    'date',
    'float'
  ];
  searchOperators = ['=', '!=', 'LIKE'];
  parameters: any = {
    search: [],
    top: 0,
    order: { by: 'ClaimOperationID', ordering: 'DESC' },
    boolOperator: 'AND',
  };

  parametersCount: any = {
    search: '',
  };

  activeButton: string = 'all';
  activeButtonState: string = 'all';
  BIN: any;
  DateLastChangeStatus: any;
  AmountSelected: any;

  formSearch: FormGroup;

  constructor(
    private ClaimOperationCP: ClaimOperationCPService,
    private CsvdownloadService: CsvdownloadService,
    private EncryptionService: EncryptionService,
    public override langService: LanguageManagerService,
    private StateMasterService: StateMasterService,
    private datePipe: DatePipe,
    public override router: Router,
    private route: ActivatedRoute,
    private StorageService: StorageService,
    private fb: FormBuilder,
    private DisputeReasons: DisputeReasons,
  ) {
    super(router, langService, route);
    this.formSearch = this.fb.group({
      searchStandard: [''], // Inicializa el campo
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.BindColumns();

    this.route.queryParams.subscribe((params) => {
      this.tabName = params['tab'];
    });
    this.DisputeReasons.GetReasons(this.subReasonsParameters).subscribe({
      next: (response) => {
        this.disputeReasons = response;

        this.disputeReasons.forEach((element) => {
          this.reasons.push(element.name.replace('@@',''));
        });
        //console.log('reasons',this.disputeReasons);
        //console.log('reasons',this.reasons);
      },
      complete() {},
    });
    this.currentFormats =
      this.langService.dateAndCurrencyChangeFormat$.subscribe((formats) => {
        this.currentFormats = formats; // Guardamos los formatos actualizados para utilizarlos
      });
    this.currentLanguage = this.langService.GetCurrentLanguage();
    this.langService.updateFormats(this.currentLanguage); // Cargar los formatos iniciales


    this.GetKpis()

    
/*     this.SearchClaimFinished('Gestionados',true);
    this.SearchClaimsOk('Final_favorable',true);
    this.SearchClaimNotOk('Final_desfavorable',true); 
    this.SearchClaimsPending('Pendientes',true);
    this.SearchClaimsExpected('Expected',true); */





    if (this.tabName != undefined) {
      switch (this.tabName) {
        case 'Pendientes':
          this.SearchClaimsPending();
          break;
        case 'Gestionados':
          this.SearchClaimFinished();
          break;
        case 'Final_favorable':
          this.SearchClaimsOk();
          break;
        case 'Final_desfavorable':
          this.SearchClaimNotOk();
          break;
        case 'All':
          this.SearchAllClaims();
          break;
        case 'Expected':
          this.SearchClaimsExpected();
          break;
        default:
          // Se muestra de inicio las disputas pendientes.
          this.SearchClaimsPending();
          break;
      }
    } else {
      this.route.paramMap.subscribe((params) => {
        this.state = params.get('state');
        switch (this.state) {
          case 'Pendientes':
            this.SearchClaimsPending();
            break;
          case 'Gestionados':
            this.SearchClaimFinished();
            break;
          case 'Expected':
            this.SearchClaimsExpected();
            break;
          case 'Final_favorable':
            this.SearchClaimsOk();
            break;
          case 'Final_desfavorable':
            this.SearchClaimNotOk();
            break;
          case 'ExpireToday':
            this.showBtnPendings = true;
            this.SearchClaimsToday();
            break;
          case 'CloseToExpire':
            this.showBtnPendings = true;
            this.SearchClaimsSoon();

            this.setActiveButton('pending');
            break;
          default:
            // Se muestra de inicio todas las disputas.
            this.SearchClaimsPending();
            break;
        }
      });
    }

    // Conteo para mostrar en los tabs pendientes/gestionadas/resueltas a favor/resueltas desfavorables
/*     this.StateMasterService.GetCountStates().subscribe(
      (res) => {
        // console.log(res);
        this.claimOperationStates = res;
        // console.log('claimOperationStates', this.claimOperationStates);
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    ); */
    // Conteo para mostrar en los tabs todos/proximas a vencimiento/ vencen hoy y top 5

/*     this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperations = res;
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    ); */


/*     this.ClaimOperationCP.ClaimOperations_GetCount(
      this.parametersCount,
    ).subscribe(
      (res) => {
        this.countClaimsOperations = res;
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    ); */

  }

  //Activacion de los botones cuadno se hace click se quedá sombreado

  alterColumnsbyTab(){
    if(this.displayColumns.length>0 && this.displayColumns.some(column => column.id === 'dateLimit')){
      const column = this.displayColumns.find(column => column.id === 'dateLimit');
      if(this.tabName === 'Expected'){
        column.name = "DCO.ClaimsClient_FechaRecepcion"
      } else {
        column.name = "DCO.OperationStatement_ExpirationDate"
      }
    }
  }

  setActiveButton(buttonName: string): void {
    this.activeButton = buttonName;
  }

  setActiveButtonState(buttonType: string): void {
    this.activeButtonState = buttonType;
  }

  //Buscar todas las disputas
  SearchAllClaims(kpi: string ="") {
    this.page = 1;
    this.showBtnPendings = false;
    this.showBtnEdit = true;
    this.showBtnVisualize = false;
    this.tabName = 'All';
    this.dueDate = true;
    this.GetClaimList(kpi);
  }

  //Buscar disputas pendientes
  SearchClaimsPending(kpi: string ="",count: boolean = false) {
    this.setActiveButton('pending');
    if(!count)
    {
      this.page = 1;
      this.showBtnPendings = true;
      this.showBtnEdit = true;
      this.showBtnVisualize = false;
      this.tabName = 'Pendientes';
      this.dueDate = true;
    }
    this.alterColumnsbyTab();

    this.GetClaimList(kpi,count);
  }

  //Buscar próximas a recibir
  SearchClaimsExpected(kpi: string ="",count: boolean = false) {
    this.setActiveButton('expected');
    if(!count)
    {
      this.page = 1;
      this.showBtnPendings = false;
      this.showBtnEdit = false;
      this.showBtnVisualize = true;
      this.tabName = 'Expected';
      this.dueDate = true;
    }
    this.alterColumnsbyTab();
    this.GetClaimList(kpi,count);
  }

  //Buscar disputas gestionadas
  SearchClaimFinished(kpi: string ="",count: boolean = false) {
    if(!count)
    {
    this.page = 1;
    this.showBtnPendings = false;
    this.showBtnEdit = true;
    this.showBtnVisualize = false;
    this.tabName = 'Gestionados';
    this.dueDate = true;
    }
    this.alterColumnsbyTab();
    this.GetClaimList(kpi,count);
  }

  //Buscar disputas resueltas a favor
  SearchClaimsOk(kpi: string ="",count: boolean = false) {
    if(!count)
    {
      this.page = 1;
      this.showBtnPendings = false;
      this.showBtnEdit = false;
      this.showBtnVisualize = true;
      this.tabName = 'Final_favorable';
      this.dueDate = false;
      this.activeButton = 'ok';
    }
    this.alterColumnsbyTab();
    this.GetClaimList(kpi,count);
  }

  //Buscar disputas resueltas desfavorable
  SearchClaimNotOk(kpi: string ="",count: boolean = false) {
    if(!count)
    {
      this.page = 1;
      this.showBtnPendings = false;
      this.showBtnEdit = false;
      this.showBtnVisualize = true;
      this.tabName = 'Final_desfavorable';
      this.dueDate = false;
      this.activeButton = 'notOk';

    }
    this.alterColumnsbyTab()
    this.GetClaimList(kpi,count);
  }

  private getDefaultParameters() {
    return {
      search: this.parameters.search,
      top: 0,
      order: {
        by: 'ClaimOperationID',
        ordering: 'DESC',
      },
      boolOperator: 'AND',
    };
  }

  //Buscador
  Search() {
    this.searchvariables = new Array();
    this.paramsearchvariables = '';

    //Relleno arreglo operador de búsqueda
    this.operatorSearchvariables[0] = this.operatorClaimID = (<
      HTMLInputElement
    >document.getElementById('select_expediente')).value;

    //console.log( this.operatorSearchvariables)

    this.operatorSearchvariables[1] = this.operatorArn = (<HTMLInputElement>(
      document.getElementById('select_arn')
    )).value;

    this.operatorSearchvariables[2] = this.operatorCommercenumber = (<
      HTMLInputElement
    >document.getElementById('select_nComercio')).value;

    this.operatorSearchvariables[3] = this.operatorSubreasonname = 'empieza';
    /* (<
      HTMLInputElement
    >document.getElementById('select4')).value; */

    this.operatorSearchvariables[4] = this.operatorBusinessactivity = (<
      HTMLInputElement
    >document.getElementById('select_actividadComercial')).value;

    this.operatorSearchvariables[5] = this.operatorOperationdate = (<
      HTMLInputElement
    >document.getElementById('select_fechaDisputa')).value;

    this.operatorSearchvariables[6] = this.operatorNombrecomercio = (<
      HTMLInputElement
    >document.getElementById('select_nombreComercio')).value;
    this.operatorSearchvariables[7] = this.operatorCardType = 'igual';
    this.operatorSearchvariables[8] = this.operatorBin = (<HTMLInputElement>(
      document.getElementById('select_BIN')
    )).value;

    this.operatorSearchvariables[9] = this.operatorLastChangeDate = (<
      HTMLInputElement
    >document.getElementById('select_DateLastChangeStatus')).value;
    this.operatorSearchvariables[10] = this.operatorAmount = (<
      HTMLInputElement
    >document.getElementById('select_Amount')).value;

    //Relleno arreglo variables de búsqueda
    this.searchvariables[0] = this.claimID;
    this.searchvariables[1] = this.arn;
    this.searchvariables[2] = this.commerceNumber;
    this.searchvariables[3] = this.subreasonName = (<HTMLInputElement>(
      document.getElementById('motivoDisputa')
    )).value;
    if (this.searchvariables[3] && this.searchvariables[3].trim() !== '') {
      this.searchvariables[3] = '@@' + this.searchvariables[3];
    }
    this.searchvariables[4] = this.businessActivity;
    this.searchvariables[5] = this.operationDate = (<HTMLInputElement>(
      document.getElementById('fechaDisputa')
    )).value;
    //console.log(this.operationDate)
    this.searchvariables[6] = this.nombreComercio;
    this.searchvariables[7] = this.cardType = (<HTMLInputElement>(
      document.getElementById('marcaTarjeta')
    )).value;
    this.searchvariables[8] = this.bin;
    this.searchvariables[9] = this.lastChangeDate = (<HTMLInputElement>(
      document.getElementById('DateLastChangeStatus')
    )).value;

    this.searchvariables[10] = (<HTMLInputElement>(
      document.getElementById('amount')
    )).value.toString();

    //console.log(this.lastChangeDate);

    // Comprobar si todos los campos de búsqueda están vacíos
    let allFieldsEmpty = this.searchvariables.every(
      (field) => field.length === 0,
    );
    if (allFieldsEmpty) {
      this.parameters.search = [];
      this.CleanSearch();
    }

    if (this.operationDate.length > 0) {
      /*    let datedaycheck = parseInt(this.operationDate.slice(8, 10));
      let datemonthcheck = parseInt(this.operationDate.slice(5, 7));
      let dateyearcheck = parseInt(this.operationDate.slice(0, 4)); */
      // console.log(datedaycheck);
      // console.log(datemonthcheck);
      // console.log(dateyearcheck);
      // console.log(this.dateNow.getDate());
      // console.log(
      //   ' ' +
      //     this.dateNow.getFullYear() +
      //     (this.dateNow.getMonth() + 1) +
      //     this.dateNow.getDate()
      // );
      //console.log(this.operationDate);
      //console.log(this.isValidDate(this.operationDate));
      if (
        !this.isValidDate(this.operationDate)
        /*         parseInt(
          this.dateNow.getFullYear() +
          (this.dateNow.getMonth() + 1) +
          this.dateNow.getDate() +
          ' '
        ) < parseInt(dateyearcheck + datemonthcheck + datedaycheck + ' ') ||
        datemonthcheck > 12 ||
        datemonthcheck < 0 ||
        datedaycheck > 31 ||
        datedaycheck < 0 ||
        dateyearcheck < 1000 ||
        dateyearcheck > 3000 */
      ) {
        window.alert('La fecha no tiene el formato correcto');
        return;
      }
    }
    if (this.lastChangeDate.length > 0) {
      /*       let datedaycheck = parseInt(this.lastChangeDate.slice(8, 10));
      let datemonthcheck = parseInt(this.lastChangeDate.slice(5, 7));
      let dateyearcheck = parseInt(this.lastChangeDate.slice(0, 4)); */
      // console.log(datedaycheck);
      // console.log(datemonthcheck);
      // console.log(dateyearcheck);
      // console.log(this.dateNow.getDate());
      // console.log(
      //   ' ' +
      //     this.dateNow.getFullYear() +
      //     (this.dateNow.getMonth() + 1) +
      //     this.dateNow.getDate()
      // );
      // console.log(' ' + dateyearcheck + datemonthcheck + datedaycheck + ' ');
      if (
        !this.isValidDate(this.lastChangeDate)
        /*         parseInt(
          this.dateNow.getFullYear() +
          (this.dateNow.getMonth() + 1) +
          this.dateNow.getDate() +
          ' '
        ) < parseInt(dateyearcheck + datemonthcheck + datedaycheck + ' ') ||
        datemonthcheck > 12 ||
        datemonthcheck < 0 ||
        datedaycheck > 31 ||
        datedaycheck < 0 ||
        dateyearcheck < 1000 ||
        dateyearcheck > 3000 */
      ) {
        window.alert('La fecha no tiene el formato correcto');
        return;
      }
    }
    for (let i = 0; i < this.searchvariables.length; i++) {
      //Validar carácteres raros
      if (
        (this.searchvariables[i] || '').length > 0 &&
        (this.searchvariables[i].includes('=') ||
          this.searchvariables[i].includes('(') ||
          this.searchvariables[i].includes(')'))
      ) {
        window.alert('El parámetro de búsqueda no está permitido');
        return;
      }
      //Validar numeros
      if (
        (this.searchvariables[i] || '').length > 0 &&
        (i == 0 || i == 1 || i == 2 || i == 8) &&
        isNaN(this.searchvariables[i]) == true
      ) {
        window.alert('El parámetro de búsqueda tiene que se un número');
        return;
      }
    }

    const operatorSearchvariablesTrans: string[] = [];

    this.operatorSearchvariables.forEach((element) => {
      switch (element) {
        case 'igual':
          operatorSearchvariablesTrans.push('=');
          break;

        case 'diferente':
          operatorSearchvariablesTrans.push('!=');
          break;

        case 'empieza':
          operatorSearchvariablesTrans.push('[]*');
          break;

        case 'termina':
          operatorSearchvariablesTrans.push('*[]');
          break;

        case 'contiene':
          operatorSearchvariablesTrans.push('*[]*');
          break;

        case 'entre':
          operatorSearchvariablesTrans.push('between');
          break;

        case 'mayor':
          operatorSearchvariablesTrans.push('>=');
          break;

        case 'menor':
          operatorSearchvariablesTrans.push('<=');
          break;
      }
    });
    this.parameters.search = [];
    //Función de búsqueda
    //Recorrer el arreglo con variables de búsqueda
    let counter: number = 0;
    /*console.log(counter, this.searchvariables)
    console.log(counter, this.searchOperators)
    console.log(counter, this.operatorSearchvariables)*/

    for (let i = 0; i < this.searchvariables.length; i++) {

      let filter;
      
      if(operatorSearchvariablesTrans[i]==='between' && this.searchvariables[i]){

        switch (this.tagsearchvariables[i]) {
          case 'Claims_DisputeStartDate':
            filter = {
              identifier: this.tagsearchvariables[i],
              value: this.searchvariables[i]+';'+this.operationDateEnd,
              type: this.typesearchvariables[i],
              operator: operatorSearchvariablesTrans[i],
            };
            break;

          case 'HistoricStates_EntryDate':
            filter = {
              identifier: this.tagsearchvariables[i],
              value: this.searchvariables[i]+';'+this.lastChangeDateEnd,
              type: this.typesearchvariables[i],
              operator: operatorSearchvariablesTrans[i],
            };
            break;

          case 'Amount':
            filter = {
              identifier: this.tagsearchvariables[i],
              value: this.searchvariables[i]+';'+this.amountEnd,
              type: this.typesearchvariables[i],
              operator: operatorSearchvariablesTrans[i],
            };
            break;

          default:
            break;
        }

      } else {
        filter = {
          identifier: this.tagsearchvariables[i],
          value: this.searchvariables[i],
          type: this.typesearchvariables[i],
          operator: operatorSearchvariablesTrans[i],
        };
      }
    

      if (!Array.isArray(this.parameters.search)) {
        this.parameters.search = [];
      }

      if (filter.value) {
        this.parameters.search.push(filter);
      }



      //Comprobación de si existen las variables de búsqueda
      /*if ((this.searchvariables[i] || '').length > 0) {
        switch (this.operatorSearchvariables[i]) {
          case 'igual':
            // console.log(counter)
            //Creación del primer elemento de búsqueda de la query
            if (counter == 0) {
              if (i == 0 || i == 1 || i == 2 || i == 4 || i == 6 || i == 7 || i == 8) {
                if (i == 8) {
                  // console.log('like')
                  this.paramsearchvariables =
                    this.tagsearchvariables[i] +
                    ' ' +
                    this.searchOperators[2] +
                    ' ' +
                    "'" +
                    this.searchvariables[i] +
                    '%' +
                    "'";
                } else {
                  // console.log('=')
                  this.paramsearchvariables =
                    this.tagsearchvariables[i] +
                    this.searchOperators[0] +
                    "'" +
                    this.searchvariables[i] +
                    "'";

                }
              } else {

                this.paramsearchvariables =
                  this.tagsearchvariables[i] +
                  ' ' +
                  this.searchOperators[2] +
                  ' ' +
                  "'" +
                  this.searchvariables[i] +
                  '%' +
                  "'";
              }
              counter = counter + 1;
              //Creación del resto de elementos de la query
            } else {

              if (i == 0 || i == 1 || i == 2 || i == 4 || i == 6 || i == 7 || i == 8) {

                if (i == 8) {

                  this.paramsearchvariables =
                    this.paramsearchvariables +
                    ' ' +
                    'and' +
                    ' ' +
                    this.tagsearchvariables[i] +
                    ' ' +
                    this.searchOperators[2] +
                    ' ' +
                    "'" +
                    this.searchvariables[i] +
                    '%' +
                    "'";
                } else {
                  this.paramsearchvariables =
                    this.paramsearchvariables +
                    ' ' +
                    'and' +
                    ' ' +
                    this.tagsearchvariables[i] +
                    this.searchOperators[0] +
                    "'" +
                    this.searchvariables[i] +
                    "'";
                }
              } else {
                this.paramsearchvariables = this.paramsearchvariables +
                  ' ' +
                  'and' +
                  ' ' +
                  this.tagsearchvariables[i] +
                  ' ' +
                  this.searchOperators[2] +
                  ' ' +
                  "'" +
                  this.searchvariables[i] +
                  '%' +
                  "'";
              }
            }
            break;
          case 'diferente':
            //Creación del primer elemento de búsqueda de la query
            if (counter == 0) {
              if (i == 0 || i == 1 || i == 2 || i == 4 || i == 6 || i == 7 || i == 8) {
                this.paramsearchvariables =
                  this.tagsearchvariables[i] +
                  this.searchOperators[1] +
                  "'" +
                  this.searchvariables[i] +
                  "'";
              } else {
                this.paramsearchvariables =
                  this.tagsearchvariables[i] +
                  this.searchOperators[1] +
                  this.searchvariables[i];
              }
              counter = counter + 1;
              //Creación del resto de elementos de la query
            } else {
              if (i == 0 || i == 1 || i == 2 || i == 4 || i == 6 || i == 7 || i == 8) {
                this.paramsearchvariables =
                  this.paramsearchvariables +
                  ' ' +
                  'and' +
                  ' ' +
                  this.tagsearchvariables[i] +
                  this.searchOperators[1] +
                  "'" +
                  this.searchvariables[i] +
                  "'";
              } else {
                this.paramsearchvariables =
                  this.paramsearchvariables +
                  ' ' +
                  'and' +
                  ' ' +
                  this.tagsearchvariables[i] +
                  this.searchOperators[1] +
                  this.searchvariables[i];
              }
            }
            break;
          case 'empieza':
            // console.log('empieza')
            //Creación del primer elemento de búsqueda de la query
            if (counter == 0) {
              this.paramsearchvariables =
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                this.searchvariables[i] +
                '%' +
                "'";
              counter = counter + 1;
              //Creación del resto de elementos de la query
            } else {
              this.paramsearchvariables =
                this.paramsearchvariables +
                ' ' +
                'and' +
                ' ' +
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                this.searchvariables[i] +
                '%' +
                "'";
            }
            break;
          case 'termina':
            //Creación del primer elemento de búsqueda de la query
            if (counter == 0) {
              this.paramsearchvariables =
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                '%' +
                this.searchvariables[i] +
                "'";
              counter = counter + 1;
              //Creación del resto de elementos de la query
            } else {
              this.paramsearchvariables =
                this.paramsearchvariables +
                ' ' +
                'and' +
                ' ' +
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                '%' +
                this.searchvariables[i] +
                "'";
            }
            break;
          case 'contiene':
            //Creación del primer elemento de búsqueda de la query
            if (counter == 0) {
              this.paramsearchvariables =
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                '%' +
                this.searchvariables[i] +
                '%' +
                "'";
              counter = counter + 1;
              //Creación del resto de elementos de la query
            } else {
              this.paramsearchvariables =
                this.paramsearchvariables +
                ' ' +
                'and' +
                ' ' +
                this.tagsearchvariables[i] +
                ' ' +
                this.searchOperators[2] +
                ' ' +
                "'" +
                '%' +
                this.searchvariables[i] +
                '%' +
                "'";
            }
            break;
        }
      }*/
    }
    //Llamada a la API con la query final
    // console.log(this.paramsearchvariables);
    //this.parameters.search = this.paramsearchvariables;
    //console.log(this.parameters);
    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperations = res.data;
        //console.log(this.claimOperations);
        this.loadGroupState();
        this.setActiveButton('');
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    );
    //Resetear la variable de búsqueda
    //this.parameters.search = '';
    this.sortColumn = '';
    this.parameters = this.getDefaultParameters();
  }

  isValidDate(dateString: string): boolean {
    if (!dateString) return false;

    const parts = dateString.split('-');
    if (parts.length !== 3) return false;

    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);

    if (
      isNaN(year) ||
      isNaN(month) ||
      isNaN(day) ||
      year < 1000 ||
      year > 3000 ||
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31
    ) {
      return false;
    }

    const date = new Date(year, month - 1, day);

    const isRealDate =
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day;

    if (!isRealDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date > today) return false;

    return true;
  }

  async loadGroupState() {
    this.lstStatesMasters = await firstValueFrom(
      this.StateMasterService.GetState(),
    );
    this.claimOperations.forEach((element) => {
      const stateMaster = this.lstStatesMasters.find(
        (s) => s.listStateMasterId.includes(element.state)
      );

      element.groupStateName = stateMaster?.stateGroup ?? '';
    });
  }

  //Buscar disputas proximas a vencimiento
  async SearchClaimsSoon(count: boolean = false) {

    this.showBtnEdit = true;
    this.page = 1;
    this.today = this.datePipe.transform(this.dateNow, 'yyyy-MM-dd');
    this.nextWeek = this.datePipe.transform(
      this.AddDays(this.dateNow, +3),
      'yyyy-MM-dd',
    );
    this.parameters  = {
      search: [],
      top: 0,
      order: { by: 'ClaimOperationID', ordering: 'DESC' },
      boolOperator: 'AND',
    };
    if (!this.lstStatesMasters || this.lstStatesMasters.length === 0){
    this.lstStatesMasters = await firstValueFrom(
      this.StateMasterService.GetState(),
    );
  }
    this.FilterByState('Pendientes');

    const filterExpDate1 = {
      identifier: 'DateLimit',
      value: this.nextWeek,
      type: 'date',
      operator: '<=',
    };

    const filterExpDate2 = {
      identifier: 'DateLimit',
      value: this.today,
      type: 'date',
      operator: '>',
    };

 //console.log(this.parameters.search)
    this.parameters.search.push(filterExpDate1, filterExpDate2);

    let totalCount=0;
    //this.parameters.search = `CO.ExpirationDate <= '${this.nextWeek}' AND CO.ExpirationDate > '${this.today}'`;
    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperations = res.data;
        totalCount=res.count?? 0;
        if(count)
        {
          this.countClaimsOperations.CloseToExpire = totalCount.toString()
          //console.log("close", this.countClaimsOperations)
        }
        this.claimOperations.forEach((element) => {
          const stateMaster = this.lstStatesMasters.find(
            (s) => s.listStateMasterId.includes(element.state)
          );
          element.groupStateName = stateMaster?.stateGroup ?? '';
        });
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    );

    this.parameters.search = [];
    this.sortColumn = '';
    this.loadCompleted = true;
  }

  //Buscar disputas vencen hoy
  async SearchClaimsToday(count: boolean = false) {
    this.page = 1;
    this.today = this.datePipe.transform(this.dateNow, 'yyyy-MM-dd');
    // this.nextWeek = this.datePipe.transform(this.AddDays(this.dateNow, +7), 'yyyy-MM-dd');

    this.parameters = {
      search: [],
      top: 0,
      order: { by: 'ClaimOperationID', ordering: 'DESC' },
      boolOperator: 'AND',
    };

    const filterExpDate2 = {
      identifier: 'DateLimit',
      value: this.today,
      type: 'date',
      operator: '=',
    };

    if (!this.lstStatesMasters || this.lstStatesMasters.length === 0){
    this.lstStatesMasters = await firstValueFrom(
      this.StateMasterService.GetState(),
    );
    }

    this.FilterByState('Pendientes');

    this.parameters.search.push(filterExpDate2);
    let totalCount=0;
    //this.parameters.search = `CO.ExpirationDate = '${this.today}'`;
    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperations = res.data;
        totalCount = res.count;
        if(count)
        {
          this.countClaimsOperations.ExpireToday = totalCount.toString()
        }
        this.claimOperations.forEach((element) => {
          const stateMaster = this.lstStatesMasters.find(
            (s) => s.listStateMasterId.includes(element.state)
          );
          element.groupStateName = stateMaster?.stateGroup ?? '';
        });
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    );
    this.parameters.search = [];
    this.loadCompleted = true;
  }

  SearchClaimsTopFive() {
    this.TopFive = true;
    this.SearchClaimsPending();
    this.parameters.search = [];
    this.loadCompleted = true;
  }

  //Limpiar busqueda
  CleanSearch() {
    //Busqueda
    this.parameters.search = [];
    this.claimID = '';
    this.operatorClaimID = '';
    this.commerceName = '';
    this.operatorCommercename = '';
    this.disputesDNI = '';
    this.operatorDisputesDNI = '';
    this.commerceNumber = '';
    this.operatorCommercenumber = '';
    this.subreasonName = '';
    this.operatorSubreasonname = '';
    this.businessActivity = '';
    this.operatorBusinessactivity = '';
    this.operationDate = '';
    this.operatorOperationdate = '';
    this.operationDateday = '';
    this.operationDatemonth = '';
    this.operationDateyear = '';
    this.operatorArn = '';
    this.operatorAmount = '';
    this.arn = '';
    this.nombreComercio = '';
    this.operatorNombrecomercio = '';
    this.cardType = '';
    this.operatorCardType = '';
    this.bin = '';
    this.operatorBin = '';
    this.lastChangeDate = '';
    this.lastChangeDateEnd = '';
    this.operationDateEnd = '';
    this.operatorLastChangeDate = '';
    this.amount = '';
    this.amountEnd = '';
    this.DateLastChangeStatus.nativeElement.value = 'igual';
    this.AmountSelected = 'igual';

    //Desplegables
    (<HTMLInputElement>document.getElementById('select_expediente')).value =
      'igual';
    (<HTMLInputElement>document.getElementById('select_arn')).value = 'igual';
    (<HTMLInputElement>document.getElementById('select_nComercio')).value =
      'igual';
    (<HTMLInputElement>(
      document.getElementById('select_actividadComercial')
    )).value = 'igual';
    (<HTMLInputElement>document.getElementById('select_fechaDisputa')).value =
      'igual';
    (<HTMLInputElement>document.getElementById('select_nombreComercio')).value =
      'igual';
    (<HTMLInputElement>document.getElementById('select_BIN')).value = 'igual';
    (<HTMLInputElement>document.getElementById('marcaTarjeta')).value = '';
    (<HTMLInputElement>document.getElementById('motivoDisputa')).value = '';

    //Checkboxes
    this.counter = 0;
    this.massiveInfoButton = false;
    this.isAllSelected = false;
    this.selectedIndices = [];
    this.claimOperationIDs = '';
    this.claimIDs = '';
    this.activeButton = 'all';

    this.SearchAllClaims();
  }

  //Boton Descargar
  DownloadClaims() {
    this.CsvdownloadService.downloadFile(
      this.claimOperations,
      'Disputes',
      this.currentFormats.currency.locale,
      this.dueDate, this.disputeColumnConfig
    );
  }

  //*** Seleccionar checkboxes
  CheckOne(
    event: any,
    claimOperationId: string,
    claimId: string,
    index: number,
  ) {
    // Calculamos el índice global del registro según la página actual
    let globalIndex = index + (this.page - 1) * 10;

    if (event.target.checked) {
      if (!this.selectedIndices.includes(globalIndex)) {
        this.selectedIndices.push(globalIndex);
      }
      this.claimOperationIDs = this.claimOperationIDs + '-' + claimOperationId;
      this.claimIDs = this.claimIDs + '-' + claimId;
      this.counter = this.selectedIndices.length;
    } else {
      this.selectedIndices = this.selectedIndices.filter(
        (i) => i !== globalIndex,
      );
      let replace = '-' + claimOperationId;
      this.claimOperationIDs = this.claimOperationIDs.replace(replace, '');
      this.claimIDs = this.claimIDs.replace(replace, '');
      this.counter = this.selectedIndices.length;
    }

    this.isAllSelected = this.isPageSelected();
    this.massiveInfoButton = this.counter > 1;

    // console.log('claimOperations', this.claimOperationIDs);
    // console.log('claimIds', this.claimIDs);
    // console.log('conteoTotal', this.selectedIndices.length);
    // console.log('esta seleccionado?', this.isAllSelected);
  }

  CheckAll(event: any) {
    if (event.target.checked) {
      this.selectedIndices = [];
      this.claimOperationIDs = '';
      this.claimIDs = '';
      for (let i = 0; i < this.claimOperations.length; i++) {
        let globalIndex = i;
        let claimOperationId = this.claimOperations[i].claimOperationID;
        let claimId = this.claimOperations[i].claimID;
        this.selectedIndices.push(globalIndex);
        this.claimOperationIDs =
          this.claimOperationIDs + '-' + claimOperationId;
        this.claimIDs = this.claimIDs + '-' + claimId;
      }
      this.counter = this.selectedIndices.length;
      this.isAllSelected = true;
    } else {
      this.selectedIndices = [];
      this.claimOperationIDs = '';
      this.claimIDs = '';
      this.counter = 0;
      this.isAllSelected = false;
    }

    this.massiveInfoButton = this.counter > 1;

    // console.log('claimOperations', this.claimOperationIDs);
    // console.log('claimIds', this.claimIDs);
    // console.log('conteoTotal', this.selectedIndices.length);
    // console.log('esta seleccionado?', this.isAllSelected);
  }

  isPageSelected(): boolean {
    // Calculamos los índices de inicio y fin de la página actual para mantener o no checkeado el checkall
    let startIndex = (this.page - 1) * 10;
    let endIndex = startIndex + this.claimOperations.length;
    for (let i = startIndex; i < endIndex; i++) {
      if (!this.selectedIndices.includes(i)) {
        return false;
      }
    }
    return true;
  }

  //***Encriptar
  NavigateDetails(claimid: string, claimoperationid: string) {
    let ids = claimid + '-' + claimoperationid;
    this.code = this.EncryptionService.encryptData(ids);
    // console.log(this.code);
    if (this.showBtnEdit) {
      this.code =
        Routes.DISPUTES_EDIT + '/' + this.EncryptionService.encode(this.code);
    } else if (this.showBtnVisualize) {
      this.code =
        Routes.DISPUTES_EDIT + '/' + this.EncryptionService.encode(this.code);
    }

    this.router.navigate([this.code], {
      queryParams: { tab: this.tabName },
    });
  }
  EncryptionMassive() {
    let encryptedMassiveClaimOperationIds = this.EncryptionService.encryptData(
      this.claimOperationIDs,
    );
    let encryptedMassiveClaimIds = this.EncryptionService.encryptData(
      this.claimIDs,
    );
    this.codemassive =
      Routes.DISPUTES_MULTIPLE_EDIT +
      '/' +
      this.EncryptionService.encode(encryptedMassiveClaimOperationIds); //+ '/' + this.EncryptionService.encode(encryptedMassiveClaimIds);
  }

  async GetKpis(){
      this.lstStatesMasters = await firstValueFrom(
        this.StateMasterService.GetState(),
      );

      this.claimOperationStates.push({
        stateGroup: 'Pendientes',
        countStates: this.lstStatesMasters.find(
          (state) => state.stateGroup === 'Pendientes'
        )?.countStates ?? '0',//result.count.toString(),
        listStateMasterId: []
      });
    
      this.claimOperationStates.push({
        stateGroup: 'Expected',
        countStates: this.lstStatesMasters.find(
          (state) => state.stateGroup === 'Expected'
        )?.countStates ?? '0',//result.count.toString(),
        listStateMasterId: []
      });

      this.claimOperationStates.push({
        stateGroup: 'Gestionados',
        countStates: this.lstStatesMasters.find(
          (state) => state.stateGroup === 'Gestionados'
        )?.countStates ?? '0',//result.count.toString(),
        listStateMasterId: []
      });

      this.claimOperationStates.push({
        stateGroup: 'Final_favorable',
        countStates: this.lstStatesMasters.find(
          (state) => state.stateGroup === 'Final_favorable'
        )?.countStates ?? '0', //result.count.toString(),
        listStateMasterId: []
      });

      this.claimOperationStates.push({
        stateGroup: 'Final_desfavorable',
        countStates: this.lstStatesMasters.find(
          (state) => state.stateGroup === 'Final_desfavorable'
        )?.countStates ?? '0', //result.count.toString(),
        listStateMasterId: []
      });

      this.SearchClaimsSoon(true);
      this.SearchClaimsToday(true);
        
  }

  /**
   * Igual que GetClaimList pero con awaits para pruebas.
   *
   */
  async GetClaimListAwaited( kpi: string ="",count: boolean = false) {
    // RDP ejemplo de como hacerlo con awaits
    this.loadCompleted = false;
    try {
      if (!this.lstStatesMasters || this.lstStatesMasters.length === 0){
        this.lstStatesMasters = await firstValueFrom(
          this.StateMasterService.GetState(),
        );
      }

      this.FilterByState(kpi);

      //console.log(JSON.stringify(this.parameters, null, 2))
      this.parameters = this.getDefaultParameters();

      // console.log(JSON.stringify(this.parameters, null, 2))
      const result = await firstValueFrom(
        this.ClaimOperationCP.ClaimOperations_Get(this.parameters),
      );

      this.claimOperations = result.data;
      this.claimOperations.forEach((element) => {
        //Se asigna el grupo de estado correspondiente a la tab seleccionada
        const stateMaster = this.lstStatesMasters.find(
          (s) => s.listStateMasterId.includes(element.state)
        );
        element.groupStateName = this.tabName ?? '';

        if(element.clientReason){
          element.subReasonName = element.clientReason
        }

      });
      //console.log(this.lstStatesMasters)
      //console.log(this.claimOperations)
//console.log(this.tabName)

      if (this.tabName == 'Pendientes') {
        let claimOperationsTopFive = this.claimOperations;
        claimOperationsTopFive = claimOperationsTopFive
          .filter((x) => x.amount != null)
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 5);

        this.topCount = claimOperationsTopFive.length;
      }

      if (this.TopFive) {
        this.claimOperations = this.claimOperations
          .filter((x) => x.amount != null)
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 5);

        this.topCount = this.claimOperations.length;
      }
      if (this.showBtnPendings && !this.TopFive) {
        this.total = this.claimOperations.length;
      }
    } catch (error) {
      this.parameters.search = [];
    }
    this.sortColumn = '';
    this.loadCompleted = true;
    this.TopFive = false;
  }
  // Recuperar lista de Claims segun la tab seleccionada
  GetClaimList( kpi: string ="", count: boolean = false) {
    this.GetClaimListAwaited(kpi, count);
    return;
  }

  // Filtrar Claims por estado: Pendientes, gestionadas, resueltas a favor, resueltas desfavorables
  FilterByState(kpi: string =""): void {
    this.parameters.search = [];
    let states: string;
    if (this.tabName != 'All' && kpi == '') {
      this.statesIds = this.lstStatesMasters
        .filter((state) => state.stateGroup === this.tabName)
        .map((state) => state.listStateMasterId);
      states = this.statesIds.join(',');
    } else if (kpi!==''){
      this.statesIds = this.lstStatesMasters
        .filter((state) => state.stateGroup === kpi)
        .map((state) => state.listStateMasterId);
      states = this.statesIds.join(',');
      //console.log(kpi,states)
    }
    else {
      this.statesIds = this.lstStatesMasters.map(
        (state) => state.listStateMasterId,
      );
      states = this.statesIds.join(',');
    }

    const filter = {
      identifier: 'State',
      value: states,
      type: 'int',
      operator: 'IN',
    };

    if (!Array.isArray(this.parameters.search)) {
      this.parameters.search = [];
    }

    this.parameters.search.push(filter);

    //this.parameters.search = `CO.State IN (${states})`;
  }

  // Calcular nextWeek para mostrar lista de claims proximas a vencimiento
  AddDays(date: Date, days: number): Date {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    // console.log(result);
    return result;
  }

  getCurrencyCode(disputeCurrency: string): string {
    return this.langService.translate(
      '@@CMP.ClaimDetails_Currency' + disputeCurrency,
    );
  }

  async SearchStandard(event: any) {
    this.parameters.search = [];
    const searchInput = (event.target as HTMLInputElement).value.trim();
    //const searchInput = value?.trim(); // Obtenemos el valor introducido

    //Si no es la tecla espacio actualiza el campo del formulario
    //if (event.key !== ' ') {
    //  this.formSearch.patchValue({ searchStandard: searchInput });
    //}

    //Si el input es vacio se llama al searchAllClaims para recuperar todas las claims
    if (!searchInput) {
      this.SearchAllClaims();
      //Si tiene valor se lanza una búsqueda con where
    } else {
      let whereClause = '';
      this.sortColumn = '';
      this.parameters.search = [];
      // Verificar si searchStandard tiene un valor
      if (searchInput) {
        const filtersConfig = [
          //{ identifier: 'Arn', type: 'int' },
          //{ identifier: 'CommerceNumber', type: 'char' },
          //{ identifier: 'CommercialName', type: 'char' },
          { identifier: 'ClaimOperationID', type: 'char' },
        ];

        if (!Array.isArray(this.parameters.search)) {
          this.parameters.search = [];
        }

        if (searchInput) {
          const filters = filtersConfig.map((f) => ({
            identifier: f.identifier,
            value: searchInput,
            type: f.type,
            operator: '*[]*',
            //boolOperator: 'OR'
          }));

          this.parameters.search.push(...filters);
          //this.parameters.boolOperator = 'OR';

          //this.parameters.BoolOperator="OR";

          //whereClause = `CO.Arn LIKE '%${searchInput}%' OR C.Name LIKE '%${searchInput}%' OR CO.CommerceNumber LIKE '%${searchInput}%' OR CO.ClaimOperationID LIKE '%${searchInput}%'`;
        }

        //this.parameters.search = whereClause;
        //console.log()
        this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
          async (res) => {
            this.claimOperations = res.data;

            this.loadGroupState();
            //console.log(this.claimOperations);
            this.setActiveButton('');
            this.parameters.search = [];
          },
          (error) => {
            if (error.status == 401) {
              this.StorageService.clean();
              this.router.navigate(['/login']);
            }
          },
        );
      }
    }
  }

  @Input() availableColumns: ColumnItem[] = [];
  @Input() selectedColumns: ColumnItem[] = [];
  versionDisputeColumnConfig: number = 1.3;
  disputeColumnConfig: string = 'DCO-Dispute-Column-Config-v' + this.versionDisputeColumnConfig.toString();
  displayColumns: ColumnItem[]=[];

  BindColumns() {
    let defaultColumns: ColumnItem[] = [
      { id: 'claimOperationID', name: 'DCO.OperationStatement_ExpedientNumber', sortable: true },
      { id: 'doc', name: 'DCO.OperationStatement_DisputeDate', sortable: true },
      { id: 'commerceNumber', name: 'DCO.ClaimsClient_CommerceNumber', sortable: true },
      { id: 'commerceName', name: 'DCO.ClaimsClient_CommerceName', sortable: true },
      { id: 'groupStateName', name: 'DCO.ClaimsClient_StateName', sortable: false },
      { id: 'subReasonName', name: 'DCO.OperationStatement_DisputeReason', sortable: true },
      { id: 'CardBrand', name: 'DCO.ClaimsClient_CardBrand', sortable: false },
      { id: 'card', name: 'DCO.ClaimsClient_Card', sortable: true },
      { id: 'amount', name: 'DCO.OperationStatement_Amount', sortable: true },
      { id: 'dateLimit', name: 'DCO.OperationStatement_ExpirationDate', sortable: true },
      { id: 'lastStatusChange', name: 'DCO.OperationStatement_LastStatusDate', sortable: true},
      {
        id: 'claimOperation_Authorization',
        name: 'DCO.ClaimsClient_AuthorizationNumber', sortable: true,
      },
      { id: 'arn', name: 'DCO.ClaimsClient_Arn', sortable: true },
      { id: 'operations_P37', name: 'DCO.OperationStatement_p37', sortable: true },
      { id: 'operations_P48', name: 'DCO.OperationStatement_p48', sortable: true },
    ];
    let disputeColumnConfiguration = this.StorageService.get(
      this.disputeColumnConfig,
    );
    if (!disputeColumnConfiguration) {
      //Se ha cambiado el version y el storage tiene una versión antigua o es la primera config para el usuario
      //Se obtiene config antigua
      let prefixColumnConfiguration = this.disputeColumnConfig.replace(/-v\d+(\.\d+)*$/, '');
      let columConfiguration: { key: string; value: any }[] = [];
      columConfiguration = this.StorageService.getByPrefix(prefixColumnConfiguration);
      if(!columConfiguration || columConfiguration.length === 0){
        //Primera config para el usuario
        this.StorageService.set(this.disputeColumnConfig, defaultColumns);
        disputeColumnConfiguration = [...defaultColumns];
        this.displayColumns = [...defaultColumns];
      } else {
        //Se actualiza la config del usuario con los name nuevos y se eliminan los ids eliminados en la nueva versión
        const savedConfig = columConfiguration[0]?.value as ColumnItem[];
        const map = new Map(defaultColumns.map(c => [c.id, c.name]));
        //Se elimina del storage la configuración antigua
        this.StorageService.remove(columConfiguration[0]?.key)
        this.displayColumns = savedConfig
          .filter(item => map.has(item.id))
          .map(item => {
            const def = defaultColumns.find(d => d.id === item.id);

            return {
              ...item,
              name: def?.name ?? item.name,
              sortable: def?.sortable ?? item.sortable,
            };
        });
        disputeColumnConfiguration = [...this.displayColumns];
        //Se guarda la nueva configuración
        this.StorageService.set(this.disputeColumnConfig, this.displayColumns);
      }
    }else{
      this.displayColumns = [...disputeColumnConfiguration];
    }
    this.availableColumns = defaultColumns.filter(
      (col) => !disputeColumnConfiguration.some((sel) => sel.id === col.id),
    );

    this.selectedColumns = disputeColumnConfiguration;
  }

  ShowDisputeColumnConfiguration(){
    let myModal = new bootstrap.Modal('#modalColumnsSelection');
    myModal.show();
  }

  SaveDisputeColumnConfiguration(){
      this.StorageService.set(this.disputeColumnConfig, this.selectedColumns);
      this.displayColumns = [...this.selectedColumns];
  }
  CancelDisputeColumnConfiguration(){
    let myModal = new bootstrap.Modal('#modalColumnsSelection');
    myModal.hide();
    this.BindColumns();
  }

  //Ordenación
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  sortBy(columnId: string) {
    if (this.sortColumn === columnId) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = columnId;
      this.sortDirection = 'asc';
    }

    this.claimOperations = [...this.claimOperations].sort((a: any, b: any) => {
      const valueA = a[columnId];
      const valueB = b[columnId];

      if (valueA == null) return 1;
      if (valueB == null) return -1;

      // ordenación por fecha
/*       if (valueA instanceof Date || valueB instanceof Date) {
        return this.sortDirection === 'asc'
          ? new Date(valueA).getTime() - new Date(valueB).getTime()
          : new Date(valueB).getTime() - new Date(valueA).getTime();
      } */

      // ordenación por números y texto
      const comparison =
        typeof valueA === 'string'
          ? valueA.localeCompare(valueB)
          : valueA > valueB ? 1 : -1;

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
  }
}
